import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles/index';
import DrawerDivider from '../../../common/components/Drawer/DrawerDivider';
import colors from '../../../../config/themeColors';

const styles = () => ({
    root: {
        marginLeft: '24px',
    },
    caption: {
        fontSize: '11px',
        color: colors.warmGrey,
    },
    subheading: {
        fontSize: '15px',
        color: colors.brownishGrey,
        marginTop: '16px',
    },
});

function MortgageType(props) {
    return (
        <div>
            <DrawerDivider/>
            <div className={props.classes.root}>
                <Typography className={props.classes.subheading}>
                    {(props.mortgageType === 'purchase') &&
                    <span>Purchase</span>
                    }
                    {(props.mortgageType === 'remortgage_current_balance') &&
                    <span>Remortage</span>
                    }
                    {(props.mortgageType === 'remortgage_and_borrow_more') &&
                    <span>Remortage and morrow more</span>
                    }
                </Typography>
                <Typography className={props.classes.caption}>
                    Type of Mortgage
                </Typography>
            </div>
        </div>
    );
}

MortgageType.propTypes = {
    mortgageType: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MortgageType);



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/components/MortgageType.js